import Axios from '../config/Axios';
import loadBreadcrumb from './ActionBreadcrumb';

export default function getPrintDocument(nDocumentId) {
  return Axios.get(`/version/print/${nDocumentId}`).then(
    (oResponse) =>
      new Promise((resolve, reject) => {
        loadBreadcrumb(oResponse.data.oDocument.fldr_nid)
          .then((aBreadcrumbFolders) => {
            resolve({
              ...oResponse.data,
              "oDocument": oResponse.data.oDocument,
              aBreadcrumbFolders
            });
          })
          .catch((oError) => reject(oError));
      })
  );
}
